// Callers MUST presign with ResponseContentDisposition=attachment, so clicking
// the anchor downloads in the current tab instead of navigating the app away
// (no blank-tab/popup workaround needed).
export const openPresignedDownload = async ({ path, token, onFailure }) => {
  if (!path) {
    return
  }
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    const body = await res.json()
    const url = res.ok ? body?.data?.url : null
    if (!url) {
      onFailure?.()
      return
    }
    const a = document.createElement('a')
    a.href = url
    a.download = ''
    a.rel = 'noopener'
    document.body.appendChild(a)
    a.click()
    a.remove()
  } catch {
    onFailure?.()
  }
}

export default openPresignedDownload
